import React from 'react';

import { Pane, ChipButton, Line } from './primitives.styles';

export type PaneCardProps = {
  children: React.ReactNode;
  className?: string;
};

/** Rounded panel used for the "Themes" and "Color & styling" blocks. */
export const PaneCard = ({ children, className }: PaneCardProps): React.ReactElement => (
  <Pane className={className}>{children}</Pane>
);

export type ChipProps = {
  children: React.ReactNode;
  onClick?: () => void;
  /**
   * Stable analytics id, forwarded to the DOM as `data-ga-id`. Pass a distinct value
   * per call site (Chip is reusable, so a shared id would collide). Omit it to let
   * the configurator's auto-capture derive one from the chip's text.
   */
  gaId?: string;
};

/** Small pill button ("See all", "Browse N themes"). */
export const Chip = ({ children, onClick, gaId }: ChipProps): React.ReactElement => (
  <ChipButton type="button" data-ga-id={gaId} onClick={onClick}>
    {children}
  </ChipButton>
);

/** Hairline divider with a soft gradient, matching the Figma line fill. */
export const Divider = (): React.ReactElement => <Line />;
